module.exports = __webpack_public_path__ + "static/softwareFactory-b9185637a5b34112fefde0a73e6acb70.png";